import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSessions(ctx,  id  ) {
      //console.log("sessions with id Fetching");
      //console.log(id.value);
      const courseg=id.value;

      //console.log('---');
    
      return new Promise((resolve, reject) => {
        axios
        .get(`/lms/admin/course/getallsessions/${courseg}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCourse(ctx, { id }) {
      //console.log("single course  Fetching");
      return new Promise((resolve, reject) => {
        axios
          .get(`/lms/admin/course/getcoursedetail/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    updateCourseInfo(ctx, { id }) {
      //console.log("update course  is launching with id : "+id);
      return ;
      return new Promise((resolve, reject) => {
        axios
          .get(`/lms/admin/course/getcoursedetail/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

   
    addCourse(ctx, userData) {

      //console.log("course session Create triggered");
      //console.log(userData);

   
      return new Promise((resolve, reject) => {
        axios
          .post('/lms/admin/course/createsession', userData )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
